var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-row",
    { attrs: { "no-gutters": "" } },
    [
      _c(
        "v-col",
        {
          attrs: { cols: "12", sm: "12", md: "12" },
          on: {
            click: function($event) {
              _vm.dialog = true
            }
          }
        },
        [
          _c(
            "div",
            {
              on: {
                click: function($event) {
                  _vm.dialog = true
                }
              }
            },
            [_vm._t("default")],
            2
          ),
          _c(
            "v-dialog",
            {
              attrs: { persistent: "", "max-width": "1200px" },
              model: {
                value: _vm.dialog,
                callback: function($$v) {
                  _vm.dialog = $$v
                },
                expression: "dialog"
              }
            },
            [
              _c(
                "v-card",
                [
                  _c(
                    "v-card-text",
                    { staticClass: "pt-3" },
                    [
                      _c("span", { staticClass: "headline" }, [
                        _vm._v(
                          _vm._s(
                            _vm.$t(
                              "components.ajaxBookingRailSelect.railBookingList"
                            )
                          )
                        )
                      ]),
                      _c("booking-general-data-table", {
                        scopedSlots: _vm._u([
                          {
                            key: "action",
                            fn: function(booking) {
                              return [
                                _c(
                                  "v-btn",
                                  {
                                    staticClass: "ma-0",
                                    attrs: {
                                      icon: "",
                                      disabled:
                                        _vm.$store.getters["Ajax/loading"],
                                      title: _vm.$t(
                                        "components.ajaxBookingRailSelect.pinBooking"
                                      )
                                    },
                                    on: {
                                      click: function($event) {
                                        return _vm.assignBooking(booking)
                                      }
                                    }
                                  },
                                  [_c("v-icon", [_vm._v("mdi-pin")])],
                                  1
                                )
                              ]
                            }
                          }
                        ])
                      })
                    ],
                    1
                  ),
                  _c(
                    "v-card-actions",
                    [
                      _c("v-spacer"),
                      _c(
                        "v-btn",
                        {
                          attrs: { color: "blue darken-1", text: "" },
                          nativeOn: {
                            click: function($event) {
                              _vm.dialog = false
                            }
                          }
                        },
                        [_vm._v(_vm._s(_vm.$t("global.close")))]
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }